
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#FFF","stroke-width":"1.5","d":"M11.098 6.263c1.697-.11 2.717.43 3.83 1.591a4.2 4.2 0 00.84.664h0l2.212 1.308c.374.221.622.572.721.96.1.39.05.816-.172 1.189a1.577 1.577 0 01-1.883.672h0L15 11.862c-.092.28-.184.547-.27.788h0l1.086 1.826c.27.395.345.703.36 1.012h0l-.247 4.567a1.796 1.796 0 01-1.897 1.692 1.8 1.8 0 01-1.688-1.602h0l-.089-3.825-.349-.432c-.361 1.187-.801 1.58-1.303 1.773h0l-4.064 1.154a1.794 1.794 0 01-1.366-.16 1.79 1.79 0 01-.771-2.286c.17-.387.477-.713.875-.902h0l2.901-1.094.385-1.71-.066.024a1.534 1.534 0 01-1.152-.112l-.144-.082-.496-4.332a1.653 1.653 0 011.191-1.569h0zm3.732-3.99a5.48 5.48 0 011.157.02c.582.066.894.127 1.79.344h0l.361 1.03 2.598 1.137-2.611.972c-.11.459-.348.88-.684 1.213-.442.44-1.052.73-1.745.756-.842.031-1.394-.092-1.77-.283a2.78 2.78 0 01-1.435-1.385 2.596 2.596 0 01-.076-2.006c.19-.507.521-.93.941-1.24a2.948 2.948 0 011.474-.559z"}})])
          )
        }
      }
    